/* eslint-disable no-unused-expressions */
/* eslint-disable no-console */
// import { defaultUnitValues, defaultSetUnitsetdict } from '../../shared/constantVariable';
import { decrypt_data, downloadFlowSheetJSON } from '../../shared/utils';

import { getWinflowsFileContent } from '../../shared/api/url-helper';
// import { removeItemFromLocalStorage } from '../../shared/removeElements';
// import { ro_elem_shared_access } from '../ro-input/ro-element-access';
// import { uploadWinFiles } from '../../shared/helper';

export const DownloadMainfile = (ele) => {
  // const {ele} = props;
  // const [modalOption, setModalOption] = useState(defaultModalOptions);

  const getUserEmail = sessionStorage.getItem('user_email');

  const getUserType = getUserEmail.split('@')[1] === 'veolia.com' ? 'internal' : 'external';

  getWinflowsFileContent(getUserEmail, ele.filename, getUserType)
    .then((res) => {
      if (res.data[0] !== '{' && res.data[0] !== undefined) {
        const res_data = res.data.split('"')[1];
        if (res_data) {
          res.data = decrypt_data(res_data);
        }
        else {
          res.data = decrypt_data(res.data);
        }
      } else {
        const final_data = JSON.parse(res.data);
        res.data = final_data;
      };
      downloadFlowSheetJSON(res.data, ele.name);
      // downloadfile(res.data, ele.name);
    })
    .catch(() => {
      // openModelPopUp('Failed to load win files', 'Error', 'error');
    });
};
// commented by chandrashekhar because we are creating a global function to download the flowsheet `downloadFlowSheetJSON` START
// const downloadfile = (json_data, fileDownloadName) => {
//   const fileName = `${fileDownloadName}.win`;
//   const data = new Blob([JSON.stringify(json_data)], { type: 'text/json' });
//   const jsonURL = window.URL.createObjectURL(data);
//   const link = document.createElement('a');
//   document.body.appendChild(link);
//   link.href = jsonURL;
//   link.setAttribute('download', fileName);
//   link.click();
//   document.body.removeChild(link);
// };
// commented by chandrashekhar because we are creating a global function to download the flowsheet `downloadFlowSheetJSON` END
// commented by chandrashekhar because un-used code 23-05-2025 START
// export const jsonFileUpload = async (event) => {
//   if (event.target.files && event.target.files[0]) {
//     let data = await uploadWinFiles(event);
//     data = JSON.parse(data.target.result);
//     // const reader = new FileReader();
//     // reader.readAsText(event.target.files[0], 'UTF-8');
//     // reader.onload = (e) => {
//     //   const data = JSON.parse(e.target.result);
//     // ############## remove dict from local storage ###########
//     removeItemFromLocalStorage();
//     // ################# Specify Flow Data ###################
//     if (data.specifyFlow_data) {
//       localStorage.setItem('flow_dict', JSON.stringify(data.specifyFlow_data));
//     }
//     if (data.feed_flow_dict_val) {
//       localStorage.setItem('feed_flow_dict', JSON.stringify(data.feed_flow_dict_val));
//     }
//     if (data.product_flow_dict_val) {
//       localStorage.setItem('product_flow_dict', JSON.stringify(data.product_flow_dict_val));
//     }
//     // ############# Chemical Dosing data ##############
//     if (data.formData_dosing && Object.keys(data.formData_dosing).length) {
//       const dosing_data = {
//         Chemical_Dosing: data.formData_dosing
//       };
//       localStorage.setItem('dosing-dict', JSON.stringify(dosing_data));
//     }
//     // ############# EDI data ##############
//     if (data.formData_edi && Object.keys(data.formData_edi).length) {
//       // ############## Temporarly converting cf id to edi id in edi-dict ############
//       const tempVar = Object.keys(data.formData_edi);
//       tempVar.forEach((item, index) => {
//         if (item.replace(/[\d_]+/g, '') === 'cf') {
//           const val = item.split('_');
//           val[0] = 'edi_';
//           tempVar[index] = val[0].concat(val[1]);
//           // ############ Dictionary to add new key value and delete prevoius keys ##################
//           Object.assign(data.formData_edi, { [tempVar[index]]: data.formData_edi[item] })[item];
//           delete data.formData_edi[item];
//         }
//       });
//       const edi_data = {
//         EDI: data.formData_edi
//       };
//       localStorage.setItem('edi-dict', JSON.stringify(edi_data));
//     }
//     // ############# ro form data ##############
//     if (data.formData_ro) {
//       // ############## Temporarly converting cls id to ro id in ro-dict ############
//       const tempVar = Object.keys(data.formData_ro);
//       tempVar.forEach((item, index) => {
//         if (item.replace(/[\d_]+/g, '') === 'cls') {
//           const val = item.split('_');
//           val[0] = 'ro_';
//           tempVar[index] = val[0].concat(val[1]);
//           // ############ Dictionary to add new key value and delete prevoius keys ##################
//           Object.assign(data.formData_ro, { [tempVar[index]]: data.formData_ro[item] })[item];
//           delete data.formData_ro[item];
//         }
//       });
//       const ro_data = {
//         ro: data.formData_ro
//       };
//       const isElementModelAccess = ro_elem_shared_access(data.formData_ro);
//       // setIsElementModelAccess(!isElementModelAccess);
//       localStorage.setItem('ro-dict', JSON.stringify(ro_data));
//     }
//     // ############# feed payload data ##############
//     if (data.payloadData_feed) {
//       const feed_payload = {
//         feed: data.payloadData_feed
//       };
//       localStorage.setItem('feed-dict', JSON.stringify(feed_payload));
//     }
//     // ############### Stripper Data ###################
//     if (data.formData_stripper && Object.keys(data.formData_stripper).length) {
//       const formdata_stripper = {
//         st: data.formData_stripper
//       };
//       localStorage.setItem('stripper-dict', JSON.stringify(formdata_stripper));
//     }
//     if (data.wex_dict && Object.keys(data.wex_dict).length) {
//       const workExcDict = {
//         work_exc: data.wex_dict
//       };
//       localStorage.setItem('work_exc-dict', JSON.stringify(workExcDict));
//       defaultSetUnitsetdict('current-unit-work', data.unitSet_dict);
//     }
//     if (data.pex_dict && Object.keys(data.pex_dict).length) {
//       const pressExcDict = {
//         press_exc: data.pex_dict
//       };
//       localStorage.setItem('press_exc-dict', JSON.stringify(pressExcDict));
//       defaultSetUnitsetdict('current-unit-work', data.unitSet_dict);
//     }
//     if (data.pelton_dict && Object.keys(data.pelton_dict).length) {
//       const peltonDict = {
//         pelton_exc: data.pelton_dict
//       };
//       localStorage.setItem('pelton_wheel-dict', JSON.stringify(peltonDict));
//       defaultSetUnitsetdict('pelton-unit-work', data.unitSet_dict);
//     }
//     if (data.turbo_dict && Object.keys(data.turbo_dict).length) {
//       const turboDict = {
//         TRD_data: data.turbo_dict
//       };
//       localStorage.setItem('turbo_charger-dict', JSON.stringify(turboDict));
//       defaultSetUnitsetdict('turbo-unit-work', data.unitSet_dict);
//     }
//     // ############# feed form data ##############
//     if (data.formData_feed) {
//       const feed_data = {
//         feed: data.formData_feed
//       };
//       localStorage.setItem('form', JSON.stringify(feed_data));
//     }
//     // ############# ro payload data ##############
//     if (data.payloadData_ro) {
//       // ############## Temporarly converting cls id to ro id in ro-dict ############
//       const tempVar = Object.keys(data.payloadData_ro);
//       tempVar.forEach((item, index) => {
//         if (item.replace(/[\d_]+/g, '') === 'cls') {
//           const val = item.split('_');
//           val[0] = 'ro_';
//           tempVar[index] = val[0].concat(val[1]);
//           // ############ Dictionary to add new key value and delete prevoius keys ##################
//           Object.assign(data.payloadData_ro, { [tempVar[index]]: data.payloadData_ro[item] })[item];
//           delete data.payloadData_ro[item];
//         }
//       });
//       const payloadData_ro = {
//         ro: data.payloadData_ro
//       };
//       localStorage.setItem('ro_payload', JSON.stringify(payloadData_ro));
//     }
//     // ############ mixer-splitter form data #########
//     if (data.formData_mixSplit && Object.keys(data.formData_mixSplit).length) {
//       const mixSplit_data = {
//         mixSplit: data.formData_mixSplit
//       };
//       localStorage.setItem('mixSplit-dict', JSON.stringify(mixSplit_data));
//     }
//     // ############# cf form data ##############
//     if (data.formData_cf) {
//       const cf_data = {
//         cf: data.formData_cf
//       };
//       localStorage.setItem('cf-dict', JSON.stringify(cf_data.cf));
//     }
//     // ############# pump form data ##############
//     if (data.formData_pump) {
//       const pump_data = {
//         pump: data.formData_pump
//       };
//       localStorage.setItem('pump-dict', JSON.stringify(pump_data.pump));
//     }
//     // ############# hppump form data ##############
//     if (data.formData_hppump) {
//       const hppump_data = {
//         hppump: data.formData_hppump
//       };
//       localStorage.setItem('hp-pump-dict', JSON.stringify(hppump_data.hppump));
//     }
//     // ################ unit set data #########
//     if (data.unitSet_dict) {
//       localStorage.setItem('system-units', JSON.stringify(data.unitSet_dict));
//     }
//     else {
//       localStorage.setItem('system-units', JSON.stringify(defaultUnitValues));
//     }
//     // ############# A&B options #################
//     if (data.ABoptions) {
//       localStorage.setItem('options', JSON.stringify(data.ABoptions));
//     }
//     // ############# Project Info #################
//     if (data.projectInfo_dict) {
//       localStorage.setItem('project_info', JSON.stringify(data.projectInfo_dict));
//     }
//     // };
//   }
// };
// Comment By chandrashekhar because Un-used code 23-05-2025 END